import * as React from 'react';

export interface ITrendToLoaderProps {
	surveyId: number;
	GetTrendGroups: (surveyId: number) => void;
	GetTrendSurveys: (surveyId: number) => void;
	GetSelectedTrendGroupId: (surveyId: number) => void;
}

export class AdminTrendToLoader extends React.Component<ITrendToLoaderProps> {
	public constructor(props: ITrendToLoaderProps) {
		super(props);

		this.load = this.load.bind(this);
	}

	public UNSAFE_componentWillMount() {
		const { surveyId } = this.props;
		if (surveyId > 0) {
			this.load(surveyId);
		}
	}

	public UNSAFE_componentWillReceiveProps(nextProps: ITrendToLoaderProps) {
		if (this.props.surveyId !== nextProps.surveyId) {
			this.load(nextProps.surveyId);
		}
	}

	public render() {
		return <></>;
	}

	public load(surveyId: number) {
		this.props.GetTrendGroups(surveyId);
		this.props.GetTrendSurveys(surveyId);
		this.props.GetSelectedTrendGroupId(surveyId);
	}
}
